import React from "react";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const PhoneSystemCard = () => {
  const isPlace = useIsPlace();
  return (
    <ZoomCard
      actions={
        isPlace ? (
          <TextButton
            className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
            size="medium"
            onClick={() => window.open("/phone_system", "_blank")}
          >
            Launch Phone System <ArrowUpRightFromSquareSolidV6 />
          </TextButton>
        ) : (
          <div
            className="hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-191266109715"
            data-hubspot-wrapper-cta-id="191266109715"
          >
            <a href="/" onClick={(e) => e.preventDefault()} target="_blank" rel="noopener noreferrer">
              <img
                alt="GET NOTIFIED"
                loading="lazy"
                src="https://no-cache.hubspot.com/cta/default/6041126/interactive-191266109715.png"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </a>
          </div>
        )
      }
      title="Phone System"
      comingSoon={!isPlace}
      subscribed={isPlace}
      description="Make it easier to connect with your leads, gain insight into your marketing campaigns, and understand your ROI like never before."
      imgSrc="/images/bg-card-phone-system.jpg"
      imgClassName="tw-mt-[24px] tw-ml-[45px] tw-mr-[-12px] tw-rounded-[6px] tw-shadow-md tw-overflow-hidden"
    />
  );
};

export default PhoneSystemCard;
